import React from "react";
import { TASKBAR_HEIGHT } from "../Taskbar";
import { chooseLayout, applyLayout } from "./layouts";

export const GAME_WINDOW_WIDTH = 620;
export const GAME_WINDOW_HEIGHT = 435;
export const FALLBACK_NEIGHBOR_COUNT = 5;

function readUiZoom() {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(
    "--ui-zoom",
  );
  const n = parseFloat(raw);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

// Pick and apply the room layout once per desktop session. App owns this
// selection so the same recorded variant determines both the windows
// Stage renders and the neighbor count sent in the websocket hello.
export default function useRoomLayout(compact) {
  const roomRef = React.useRef(undefined);

  if (!compact && roomRef.current === undefined) {
    const zoom = readUiZoom();
    const W = window.innerWidth / zoom;
    const H = window.innerHeight / zoom;
    const chosen = chooseLayout(W, H);
    roomRef.current = chosen
      ? applyLayout(chosen, {
          W,
          H,
          winW: GAME_WINDOW_WIDTH,
          winH: GAME_WINDOW_HEIGHT,
          taskbar: TASKBAR_HEIGHT,
        })
      : null;
  }

  return roomRef.current ?? null;
}
